import * as React from 'react'
import styled from 'styled-components'

interface IProps {
  name: string,
}

class Footer extends React.Component<IProps> {
  public render() {
    return (
      <PrintFooter className="print-footer">
        <div>
          <span className="footer-left-text" >{this.props.name}</span>
          <span className="footer-right-text" />
        </div>
      </PrintFooter>
    )
  }
}

const PrintFooter = styled.div`
  position: absolute;
  -webkit-print-color-adjust:exact;
  bottom: 15px;
  left: 0;
  right: 0;
  height: 70px;
  background-color: #1A4C7A;
  border-color: transparent;
`
export default Footer



// WEBPACK FOOTER //
// ./src/atoms/PrintFooter/PrintFooter.tsx